import { Avatar } from "@/shared-web.ui/ui.avatar";
import { Checkbox } from "@/shared-web.ui/ui.checkbox";
import { Flex } from "@/shared-web.ui/ui.flex";
import { HardLink } from "@/shared-web.ui/ui.link";
import { Text } from "@/shared-web.ui/ui.text";
import { type CartItem as CartItemType, type ShopDetail } from "@/stf.data/schema";

import { useCartContext } from "./cart.context";
import { CartItem } from "./cart-item.feat";
import { reduceShopState } from "./hook.use-cart";

interface ShopCartProps {
  itemList: CartItemType[];
  shopDetail: ShopDetail;
}

const ShopCart = (props: ShopCartProps) => {
  const {
    itemList,
    shopDetail,
  } = props;
  const {
    shopLogo,
    shopName,
    shopSlug,
  } = shopDetail;

  const shopItemList = itemList.filter((cartItem) => {
    const { shopDetail: { shopSlug: itemShopSlug } } = cartItem;

    return itemShopSlug === shopSlug;
  });

  const { dispatchCartAction, cartState } = useCartContext();
  const { selectedCartItemId, cartData } = cartState;

  const shopCheckedState = reduceShopState({
    cartData,
    selectedCartItemId,
    shopSlug,
  });

  const handleToggleShop = () => {
    dispatchCartAction({
      type: "toggleShop",
      payload: shopSlug,
    });
  };

  return (
    <Flex
      className="rounded-2 bg-panel shadow-2"
      direction="column"
      gap="3"
      px="3"
      py="4"
    >
      <Flex
        align="center"
        direction="row"
        gap={{
          initial: "2",
          xs: "3",
        }}
      >
        <Checkbox
          checked={shopCheckedState}
          onCheckedChange={handleToggleShop}
          size="2"
        />
        <Flex
          align="center"
          gap="2"
        >
          <Avatar
            alt={shopName}
            fallback={shopName[0]}
            radius="full"
            size="1"
            src={shopLogo}
          />
          <HardLink href={`/shop/${shopSlug}`}>
            <Text color="gray" highContrast>
              {shopName}
            </Text>
          </HardLink>
        </Flex>
      </Flex>
      <Flex
        direction="column"
        gap="6"
      >
        {shopItemList.map((item) => {
          return (
            <CartItem
              key={item.cartItemId}
              {...item}
            />
          );
        })}
      </Flex>
    </Flex>
  );
};

export {
  ShopCart,
  type ShopCartProps,
};
